import React, { useMemo, useState } from "react";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import Icon from "../../../components/AppIcon";

const PayableFilterBar = ({
  onFiltersChange,
  onRefresh,
  isLoading,
  supplierCategories = [],
}) => {
  const [filters, setFilters] = useState({
    searchTerm: "",
    paymentStatus: "all",
    agingPeriod: "all",
    supplierCategory: "all",
    amountRange: "all",
  });

  const paymentStatusOptions = useMemo(
    () => [
      { value: "all", label: "Todos os Status" },
      { value: "pending", label: "Pendente" },
      { value: "overdue", label: "Vencido" },
      { value: "paid", label: "Pago" },
    ],
    []
  );

  const agingPeriodOptions = useMemo(
    () => [
      { value: "all", label: "Todos os Períodos" },
      { value: "current", label: "0-30 dias" },
      { value: "31-60", label: "31-60 dias" },
      { value: "61-90", label: "61-90 dias" },
      { value: "over90", label: "+90 dias" },
    ],
    []
  );

  const supplierCategoryOptions = useMemo(() => {
    const base = [{ value: "all", label: "Todas as Categorias" }];

    const unique = Array.from(
      new Set((supplierCategories || []).map((c) => String(c || "").trim()))
    ).filter(Boolean);

    return [
      ...base,
      ...unique.map((c) => ({
        value: c,
        label: c,
      })),
    ];
  }, [supplierCategories]);

  // MANTIDO: suas faixas de valores (não alterei)
  const amountRangeOptions = useMemo(
    () => [
      { value: "all", label: "Todos os Valores" },
      { value: "0-1000", label: "Até R$ 1.000" },
      { value: "1000-5000", label: "R$ 1.000 - R$ 5.000" },
      { value: "5000-10000", label: "R$ 5.000 - R$ 10.000" },
      { value: "10000+", label: "Acima de R$ 10.000" },
    ],
    []
  );

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange?.(newFilters);
  };

  const handleClearFilters = () => {
    const cleared = {
      searchTerm: "",
      paymentStatus: "all",
      agingPeriod: "all",
      supplierCategory: "all",
      amountRange: "all",
    };
    setFilters(cleared);
    onFiltersChange?.(cleared);
  };

  const hasActiveFilters = useMemo(() => {
    return Object.entries(filters).some(([key, value]) =>
      key === "searchTerm" ? value.trim() !== "" : value !== "all"
    );
  }, [filters]);

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-8 card-shadow">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading-semibold text-lg text-card-foreground">
          Filtros e Pesquisa
        </h3>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onRefresh}
            disabled={isLoading}
          >
            <Icon name="RefreshCw" size={16} />
            <span className="ml-2">
              {isLoading ? "Atualizando..." : "Atualizar"}
            </span>
          </Button>

          {hasActiveFilters && (
            <Button variant="outline" size="sm" onClick={handleClearFilters}>
              <Icon name="X" size={16} />
              <span className="ml-2">Limpar</span>
            </Button>
          )}

          <Button variant="primary" size="sm">
            <Icon name="Download" size={16} />
            <span className="ml-2">Exportar Filtrados</span>
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
        <div className="md:col-span-2">
          <Input
            value={filters.searchTerm}
            onChange={(e) => handleFilterChange("searchTerm", e.target.value)}
            placeholder="Buscar fornecedor ou nota fiscal..."
          />
        </div>

        <div>
          <Select
            value={filters.paymentStatus}
            onChange={(value) => handleFilterChange("paymentStatus", value)}
            options={paymentStatusOptions}
            placeholder="Status"
          />
        </div>

        <div>
          <Select
            value={filters.agingPeriod}
            onChange={(value) => handleFilterChange("agingPeriod", value)}
            options={agingPeriodOptions}
            placeholder="Período"
          />
        </div>

        <div>
          <Select
            value={filters.amountRange}
            onChange={(value) => handleFilterChange("amountRange", value)}
            options={amountRangeOptions}
            placeholder="Valores"
          />
        </div>
      </div>
    </div>
  );
};

export default PayableFilterBar;
